module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/services/store-services.component.css
// module id = ./src/app/indi-store/services/store-services.component.css
// module chunks = main